import React from 'react'
import Spinner from "./Spinner";

function LazyPageLoader() {
  return   <div className={"d-flex items-center justify-content-center"} style={{paddingTop:100}}>
    <Spinner size={"lg"} /></div>;
}

export default LazyPageLoader
